// 统一核保 
import { underWriting } from '@/model/trader/orderService'
import { Parameter } from '@/utils/orderParme'
import { store, mutations } from '@/observable/store'


export default {
    data(){
        return{
            insuranceToReviewload:false
        }
    },
    methods: {
        insuranceDataformat(obj){
            console.log('1111-insuranceDataformat',obj)

            let data = obj;
            let applicant = {
                name:obj.name,
                phone:obj.phone,
                idcard:obj.idcard,
            }
            data.applicant = applicant

            const parameter = Parameter(data)
            return parameter
            // let obj = {
            //     "pay_period": "year",
            //     "applicant": {
            //       "phone": "18410705070",
            //       "name": "六六",
            //       "idcard": "513436198310167090"
            //     },
            //     "insure": [
            //       {
            //         "phone": "18410705070",
            //         "name": "六六",
            //         "idcard": "513436198310167090",
            //         "coverage": 600000000,
            //         "relation": "self",
            //         "social_security": 0
            //       }
            //     ],
            //     "template": "ta_tw"
            // }
                    // order_id:this.orderId,
                    // 'is_event':this.isEvent,
                    // "is_edit":this.isEdit,
                    // "name":this.applicantNameInfo.name,//姓名
                    // "idcard":this.applicantIDcardInfo.idcard,//身份证号码
                    // "phone":this.applicantPhoneInfo.phone,
                    // "social_security":this.security, //0-无社保, 1-有社保
                    // "tmpl":this.templateFlag,
                    // traceback:store.TXoption.bizKey,
                    // ---
                    // system:systemFlag,
                    // name:this.applicantNameInfo.name,//姓名
                    // idcard:this.applicantIDcardInfo.idcard,//身份证号码
                    // phone:this.applicantPhoneInfo.phone,
                    // social_security:this.security, //0-无社保, 1-有社保
                    // tmpl:this.templateFlag,
                    // from_action: Array.isArray(this.$route.query.from_action)?this.$route.query.from_action[0] : this.$route.query.from_action ||store.refid.item_id || '',
                    // traceback:store.TXoption.bizKey,
                    // ----
                    // uuid:this.$route.query.uuid,
                    // hospital_id:this.appointment.outpatient.hospital_id,
                    // appointment_at:this.appointment.time,
                    // phone:this.info.phone.name,
                    // name:this.info.name.name,
                    // idcard:this.info.idCard.name,
                    // traceback:store.TXoption.bizKey,
            // return obj
        },
        insuranceToReview(data,type,review = true){
            console.log('22222-insuranceToReview',data)
            console.log('22222-insuranceToReview',review)
            if(this.insuranceToReviewload){
                return false
            }
            this.insuranceToReviewload = true;
            if(review){
                this.$loading.show()

                underWriting(data).then(res =>{
                //     console.log(res)
                    // 存储核保参数 在重要信息确认页 确认时投保
                        mutations.setInsuranceParmes(data);
                        this.$loading.hide()
                        this.insuranceToReviewload = false;
                        this.$router.push({
                            name:'confirmed',
                            query:{
                                templateFlag:data.template,
                                reviewType:type, //投保类型 （creatOrder，couponUse，receive，preIdentity）
                                flag : 'postdisable'
                            }
                        });
                        
                }).catch((err) => {
                    this.$loading.hide()
                    this.insuranceToReviewload = false;
                    this.$toast(err.message);
                    //增加保年龄错误样式 this.addPattern 只在details有样式体现 。其他地方只有toast提示
                    if(this.addPattern){ 
                        this.addPattern(err.code);
                    } 
                }).finally(()=>{
                    this.$loading.hide()
                    this.insuranceToReviewload = false;
                })
                ;
            }else{
                this.insuranceToReviewload = false;
                mutations.setInsuranceParmes(data);
                this.$router.push({
                    name:'confirmed',
                    query:{
                        templateFlag:data.template,
                        reviewType:type, //投保类型 （creatOrder，couponUse，receive，preIdentity）
                        flag : 'postdisable'
                    }
                });
            }
            
        }
      
    },
  }